import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  & > h2 {
    margin-bottom: 16px;
  }
  gap: 8px;

  .MuiFormControl-root:first-of-type {
    padding-bottom: 8px;
  }

  .MuiLink-root {
    padding: 0;
    margin-top: 8px;
  }
`;

const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
`;

const CTAWrapper = styled.div`
  border-top: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  padding: 16px;
  position: fixed;
  bottom: 0;
  background: ${color(COLOR_VARIANTS.WHITE)};
  width: 100%;
`;

const AirlineImage = styled.img`
  border-radius: 50%;
  border: 0.5px solid ${color(COLOR_VARIANTS.GAINSBORO)};
`;

const AirlineShowLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default {
  CellWrapper,
  Wrapper,
  ListItem,
  CTAWrapper,
  AirlineImage,
  AirlineShowLink,
};
